import { DialogService, GridAction } from '@eforall/dashboard';
import { Commitment } from '@interfaces';

export function getActions(dialogService: DialogService) {

	const actions: GridAction<Commitment>[] = [
		// {
		// 	iconClass: 'fa-regular fa-filter-list',
		// 	label: 'View Aligned Prospects',
		// 	isEnabled: rows => !!rows.length,
		// 	execute: async rows => {
		// 		await dialogService.showMessage('Aligned Prospects', 'TBD');
		// 	}
		// },
		// {
		// 	iconClass: 'fa-regular fa-file-lines',
		// 	label: 'View Aligned Applications',
		// 	isEnabled: rows => !!rows.length,
		// 	execute: async rows => {
		// 		await dialogService.showMessage('Aligned Applications', 'TBD');
		// 	}
		// },
	];

	return actions;
}